// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Eb-z","landingPageVideo":"Fb-z","play":"Gb-z","iframeVideo":"Hb-z","playHidden":"Ib-z","fullwidth":"Jb-z"};